import React, { useContext, useEffect, useState } from 'react';
import { Backdrop, Button, CircularProgress, Divider } from '@material-ui/core';

import { useJiraLogin } from '../user/User.hooks';
import { User } from '../user/User.interface';
import { FetchError } from '../common/api/api';
import environment from '../environments';
import { useJiraConnectAPI } from '../secure-portal/jira-connect/JiraConnect.hooks';
import { LoginContext } from './Login.context';
import { StyledLoginContainer } from './JiraLogin.styled';

const JiraLogin: React.FC<{
  email?: string;
  disabled?: boolean;
  onLogin: (user: User) => void;
  onError: (error: FetchError) => void;
}> = ({
  email,
  disabled = false,
  onLogin,
  onError,
}) => {
    const [token, setToken] = useState('');
    const { connect, isAvailable } = useJiraConnectAPI();
    const { didLogout } = useContext(LoginContext);
    const { user, isLoading, error, jiraLogin } = useJiraLogin();

    useEffect(() => {
      // prevent auto login after logging out
      if (isAvailable && environment.jiraAutoLogin && !didLogout && token) {
        jiraLogin(token, email);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, isAvailable, jiraLogin]);

    useEffect(() => {
      if (connect && connect.context) {
        connect.context.getToken(t => setToken(t));
      }
    }, [connect]);

    useEffect(() => {
      if (user && onLogin) {
        onLogin(user);
      }
      if (error && onError) {
        onError(error);
      }
    }, [user, error, onLogin, onError]);

    if (!isAvailable) {
      return <></>;
    }

    return (
      <StyledLoginContainer>
        <Divider variant='middle' data-content='OR' />
        <Button
          variant='contained'
          disableElevation
          type='submit'
          color='primary'
          disabled={disabled || isLoading}
          onClick={() => {
            jiraLogin(token, email);
          }}
        >
          Log In with JIRA
      </Button>

        <Backdrop className='backdrop' open={isLoading}>
          <CircularProgress color='inherit' />
        </Backdrop>
      </StyledLoginContainer>
    );
  };

export default JiraLogin;
